import React, { Component } from 'react';

class IconArrowUp extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="16"
                fill="none"
                viewBox="0 0 20 16"
            >
                <rect width="20" height="16" fill="#E6EEF5" rx="2"></rect>
                <path
                    fill="#26A"
                    d="M10.012 6.435l-5.655 5.21a1.332 1.332 0 01-.428.263 1.416 1.416 0 01-1.01 0 1.332 1.332 0 01-.427-.264 1.214 1.214 0 01-.286-.394 1.131 1.131 0 010-.93c.066-.146.163-.28.286-.393L10.012 3l7.497 6.904c.122.112.22.246.285.394a1.13 1.13 0 010 .929 1.212 1.212 0 01-.285.394 1.333 1.333 0 01-.428.263 1.418 1.418 0 01-1.01 0 1.332 1.332 0 01-.427-.263l-5.632-5.186z"
                ></path>
            </svg>
        );
    }
}

export default IconArrowUp;